var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoiximanStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9683 7.40846C32.8863 3.19851 27.5699 0.878906 22.0001 0.878906C16.4251 0.878906 11.1087 3.19851 7.02407 7.41113C2.8781 11.6877 0.601158 17.4334 0.779794 23.1765C1.28371 39.451 20.4537 52.1235 21.2723 52.6541L21.9895 53.1207L22.7147 52.6621C23.5305 52.1449 42.714 39.779 43.2205 23.1738C43.3965 17.4334 41.1169 11.6851 36.9683 7.40846Z",
    fill: "#1365D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40991 22.1126C7.40991 30.1581 13.957 36.7 22.0025 36.7C30.048 36.7 36.5899 30.1581 36.5899 22.1126C36.5899 14.0668 30.048 7.51953 22.0025 7.51953C13.957 7.51953 7.40991 14.0668 7.40991 22.1126Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2233_677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4517 32.1094L14.4444 27.4622H18.555C19.0755 27.4461 19.5745 27.1885 19.9287 26.7539C20.3741 26.2065 20.3419 25.4874 20.24 24.983C20.24 24.983 19.1023 19.5524 18.9843 18.946C18.5496 16.7082 19.3116 14.4652 20.9268 13.2256C21.7157 12.6192 22.687 12.2435 23.728 12.1362C23.9534 12.1147 24.1788 12.1094 24.3881 12.1094H30.5539L29.5665 16.7404H25.8745C25.2574 16.7404 24.5652 16.8263 24.1037 17.4327C23.9695 17.5883 23.8675 17.7654 23.7978 17.9854C23.6153 18.565 23.7387 19.1231 23.8461 19.6221C23.8622 19.6919 24.8657 24.5322 24.8657 24.5322C24.9891 25.1333 25.1071 25.6967 25.1286 26.287C25.1823 27.8003 24.7315 29.2062 23.8461 30.2527C23.0465 31.1971 21.882 31.8357 20.5673 32.045C20.2292 32.0986 19.8858 32.1094 19.4726 32.1094H13.4463H13.4517Z",
    fill: "#1365D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2233_677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8116,
    height: 20,
    fill: "white",
    transform: "translate(13.5942 12.1094)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoiximanStorePin);
export default __webpack_public_path__ + "static/media/StoiximanStorePin.3a10550346585440f07bc2b3efc2a98b.svg";
export { ForwardRef as ReactComponent };